import { membersBaseURL } from "@/functions/helpers";

const baseURL = membersBaseURL();

const _post = (url, params, config = {}) =>
  window.axios.post(url, params, { baseURL, ...config });
const _put = (url, params) => window.axios.put(url, params, { baseURL });
const _delete = url => window.axios.delete(url, { baseURL });
const _get = url => window.axios.get(url, { baseURL });

export default {
  getBlingHtml(context, token) {
    return new Promise((resolve, reject) => {
      return window.axios
        .get(`integrations/bling/render-login/${token}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(reject);
    });
  },
  getBlingCallbackUrl(context) {
    return new Promise((resolve, reject) => {
      return window.axios
        .get(`integrations/bling/callback/url`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(reject);
    });
  },

  getFunnelControlToken(context) {
    return new Promise((resolve, reject) => {
      return window.axios
        .get(`integrations/funnel-control/token`)
        .then(({ data }) => resolve(data))
        .catch(reject);
    });
  },

  // Integration
  getIntegration(context, params) {
    const integration = context.state.integration;
    const queryString = new URLSearchParams(params);
    return new Promise((resolve, reject) => {
      return window.axios
        .get(`integrations/${integration}?${queryString}`)
        .then(({ data: { results, count, next, previous } }) => {
          context.commit("setPagination", { count, next, previous });
          context.commit("setIntegrationList", results);
          resolve({ results, count, next, previous });
        })
        .catch(reject);
    });
  },
  postIntegration(context, data) {
    const integration = context.state.integration;
    return new Promise((resolve, reject) => {
      const provider = integration == "integrat" ? _post : window.axios.post;
      return provider(`/integrations/${integration}`, data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(reject);
    });
  },
  putIntegration(context, data) {
    const integration = context.state.integration;
    return new Promise((resolve, reject) => {
      const provider = integration == "integrat" ? _put : window.axios.put;
      const url =
        integration == "integrat"
          ? `integrations/${integration}/product/${data.product_id}`
          : `integrations/${integration}/${data.id}`;
      return provider(url, data)
        .then(({ data }) => {
          resolve({ data });
        })
        .catch(reject);
    });
  },
  deleteIntegration(context, id) {
    const integration = context.state.integration;
    return new Promise((resolve, reject) => {
      const provider =
        integration == "integrat" ? _delete : window.axios.delete;
      const url =
        integration == "integrat"
          ? `integrations/${integration}/product/${id}`
          : `integrations/${integration}/${id}`;
      return provider(url)
        .then(({ data }) => {
          resolve({ data });
        })
        .catch(reject);
    });
  },

  // Providers
  getProviders(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params);
      return window.axios
        .get(`/integrations/provider?${queryString}`)
        .then(({ data: { results, count, next, previous } }) => {
          context.commit("setProviders", results);
          context.commit("setPagination", { count, next, previous });
          resolve({ data: { results, count, next, previous } });
        })
        .catch(reject);
    });
  },
  getTypeProviders(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params);
      return window.axios
        .get(`/integrations/type-provider?${queryString}`)
        .then(({ data }) => {
          const list = Object.keys(data).map(key => ({ key, name: data[key] }));
          context.commit("setProviders", list);
          resolve(list);
        })
        .catch(reject);
    });
  },
  postProvider(context, provider) {
    return new Promise((resolve, reject) => {
      return window.axios
        .post(`/integrations/provider`, provider)
        .then(resolve)
        .catch(reject);
    });
  },
  putProvider(context, provider) {
    return new Promise((resolve, reject) => {
      return window.axios
        .put(`/integrations/provider/${provider.id}`, provider)
        .then(resolve)
        .catch(reject);
    });
  },
  deleteProvider(context, id) {
    return new Promise((resolve, reject) => {
      return window.axios
        .delete(`/integrations/provider/${id}`)
        .then(resolve)
        .catch(reject);
    });
  },

  getActiveCampaignTags(context, params) {
    const queryString = new URLSearchParams(params);
    return new Promise((resolve, reject) => {
      return window.axios
        .get(`/integrations/active-campaign/search-tag?${queryString}`)
        .then(({ data }) => {
          context.commit("setTags", data);
          resolve();
        })
        .catch(reject);
    });
  },

  getLeadLoversTags(context, params) {
    const queryString = new URLSearchParams(params);
    return new Promise((resolve, reject) => {
      return window.axios
        .get(`/integrations/leadlovers/search-tags?${queryString}`)
        .then(({ data }) => {
          context.commit(
            "setTags",
            data.response.Tags.map(t => ({
              ...t,
              id: t.Id,
              name: t.Title
            }))
          );
          resolve(data);
        })
        .catch(reject);
    });
  },

  getMachines(context, params) {
    const queryString = new URLSearchParams(params);
    return new Promise((resolve, reject) => {
      return window.axios
        .get(`/integrations/leadlovers/search-machines?${queryString}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(reject);
    });
  },
  getSequencies(context, params) {
    const queryString = new URLSearchParams(params);
    return new Promise((resolve, reject) => {
      return window.axios
        .get(`/integrations/leadlovers/search-email-sequence?${queryString}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(reject);
    });
  },
  getSequenceLevel(context, params) {
    const queryString = new URLSearchParams(params);
    return new Promise((resolve, reject) => {
      return window.axios
        .get(`/integrations/leadlovers/search-sequence-level?${queryString}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(reject);
    });
  },

  // Event Types
  getTypeEvents(context) {
    return new Promise((resolve, reject) => {
      return window.axios
        .get(`/integrations/type-events`)
        .then(({ data }) => {
          const list = Object.keys(data).map(key => ({
            id: key,
            name: data[key]
          }));
          context.commit(
            "setTypeEvents",
            list.filter(event => event?.id !== "disable")
          );
          resolve({ data });
        })
        .catch(reject);
    });
  },

  // Command Types
  getTypeCommands(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params);
      return window.axios
        .get(`/integrations/type-commands?${queryString}`)
        .then(({ data }) => {
          const list = Object.keys(data).map(key => ({
            id: key,
            name: data[key]
          }));
          context.commit("setTypeCommands", list);
          resolve({ data });
        })
        .catch(reject);
    });
  },

  // Webhook
  testWebhook(context, data) {
    return new Promise((resolve, reject) => {
      return window.axios
        .post(`/integrations/generic/send-event-test`, data)
        .then(({ url }) => {
          resolve({ url });
        })
        .catch(reject);
    });
  },

  // Lead List
  getLeadLists(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params);
      return window.axios
        .get(`/integrations/lead-list/${params.product_id}?${queryString}`)
        .then(({ data: { results, count, next, previous } }) => {
          context.commit("setEvents", results);
          context.commit("setPagination", { count, next, previous });
          resolve({ data: { results, count, next, previous } });
        })
        .catch(reject);
    });
  },

  // Events
  getEvents(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params);
      return window.axios
        .get(`/integrations/events?${queryString}`)
        .then(({ data: { results, count, next, previous } }) => {
          context.commit("setEvents", results);
          context.commit("setPagination", { count, next, previous });
          resolve({ data: { results, count, next, previous } });
        })
        .catch(reject);
    });
  },
  postEvents(context, event) {
    return new Promise((resolve, reject) => {
      return window.axios
        .post(`/integrations/events`, event)
        .then(resolve)
        .catch(reject);
    });
  },
  putEvents(context, event) {
    return new Promise((resolve, reject) => {
      return window.axios
        .put(`/integrations/events/${event.id}`, event)
        .then(resolve)
        .catch(reject);
    });
  },
  deleteEvents(context, id) {
    return new Promise((resolve, reject) => {
      return window.axios
        .delete(`/integrations/events/${id}`)
        .then(resolve)
        .catch(reject);
    });
  },

  // Kajabi
  getKajabi(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params);
      return window.axios
        .get(`/integrations/kajabi?${queryString}`)
        .then(({ data: { results, count, next, previous } }) => {
          context.commit("setPagination", { count, next, previous });
          context.commit("setKajabiList", results);
          resolve({ results, count, next, previous });
        })
        .catch(reject);
    });
  },
  postKajabi(context, data) {
    return new Promise((resolve, reject) => {
      return window.axios
        .post(`/integrations/kajabi`, data)
        .then(({ data }) => {
          resolve({ data });
        })
        .catch(reject);
    });
  },
  putKajabi(context, data) {
    return new Promise((resolve, reject) => {
      return window.axios
        .put(`/integrations/kajabi/${data.id}`, data)
        .then(({ data }) => {
          resolve({ data });
        })
        .catch(reject);
    });
  },
  deleteKajabi(context, id) {
    return new Promise((resolve, reject) => {
      return window.axios
        .delete(`/integrations/kajabi/${id}`)
        .then(({ data }) => {
          resolve({ data });
        })
        .catch(reject);
    });
  },
  getKajabiById(context, id) {
    return new Promise((resolve, reject) => {
      return window.axios
        .get(`/integrations/kajabi/${id}`)
        .then(({ data }) => {
          context.commit("setKajabiIntegration", data);
          resolve({ data });
        })
        .catch(reject);
    });
  },

  // eNotas
  getENotas(context, params) {
    const queryString = new URLSearchParams(params);
    return new Promise((resolve, reject) => {
      return window.axios
        .get(`integrations/enotas?${queryString}`)
        .then(({ data: { results, count, next, previous } }) => {
          context.commit("setPagination", { count, next, previous });
          context.commit("setIntegrationList", results);
          resolve({ results, count, next, previous });
        })
        .catch(reject);
    });
  },
  postENotas(context, data) {
    return new Promise((resolve, reject) => {
      return window.axios
        .post(`/integrations/enotas`, data)
        .then(({ data }) => {
          resolve({ data });
        })
        .catch(reject);
    });
  },
  putENotas(context, data) {
    return new Promise((resolve, reject) => {
      return window.axios
        .put(`integrations/enotas/${data.id}`, data)
        .then(({ data }) => {
          resolve({ data });
        })
        .catch(reject);
    });
  },
  deleteENotas(context, id) {
    return new Promise((resolve, reject) => {
      return window.axios
        .delete(`integrations/enotas/${id}`)
        .then(({ data }) => {
          resolve({ data });
        })
        .catch(reject);
    });
  },
  getENotasById(context, id) {
    return new Promise((resolve, reject) => {
      return window.axios
        .get(`integrations/enotas/${id}`)
        .then(({ data }) => {
          context.commit("setIntegration", data);
          resolve({ data });
        })
        .catch(reject);
    });
  },

  //Clicksign
  postClicksignIntegration(context, data) {
    return new Promise((resolve, reject) => {
      return window.axios
        .post(`integrations/clicksign`, data)
        .then(({ data }) => {
          resolve(data.id);
        })
        .catch(reject);
    });
  },
  createDocument(context, data) {
    return new Promise((resolve, reject) => {
      const id = data.integration_id;
      delete data.integration_id;
      return window.axios
        .post(`/integrations/clicksign/${id}/documents/create`, data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(reject);
    });
  },
  getDocument(context, params) {
    return new Promise((resolve, reject) => {
      return window.axios
        .get(
          `/integrations/clicksign/${params.integration_id}/event/${params.event_id}`
        )
        .then(({ data }) => resolve(data));
    });
  },
  getClicksignEvent(context, data) {
    return new Promise((resolve, reject) => {
      return window.axios
        .get(`/integrations/clicksign/${data}/event`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(reject);
    });
  },
  postClicksignEvent(context, data) {
    return new Promise((resolve, reject) => {
      return window.axios
        .post(
          `/integrations/clicksign/${data.integration_id}/event`,
          data.params
        )
        .then(resolve)
        .catch(reject);
    });
  },
  putClicksignIntegration(context, data) {
    return new Promise((resolve, reject) => {
      return window.axios
        .put(`/integrations/clicksign/${data.integration_id}`, {
          token: data.token,
          description: data.description
        })
        .then(resolve)
        .catch(reject);
    });
  },
  putClicksignEvent(context, data) {
    return new Promise((resolve, reject) => {
      return window.axios
        .put(
          `/integrations/clicksign/${data.integration_id}/event/${data.event_id}`,
          data.params
        )
        .then(resolve)
        .catch(reject);
    });
  },
  // Zoom
  getAllZoom(context, params) {
    return new Promise((resolve, reject) => {
      const query_params = new URLSearchParams(params).toString();
      return _get(`/meet/zoom?${query_params}&limit=999`)
        .then(({ data }) => {
          if (!Object.keys(params).length) {
            context.commit("setAllZoomIntegrations", data.results);
          }
          resolve(data.results);
        })
        .catch(reject);
    });
  },
  getZoom(context, product_id) {
    return new Promise((resolve, reject) => {
      return _get(`/meet/zoom/${product_id}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(reject);
    });
  },
  postZoom(context, data) {
    return new Promise((resolve, reject) => {
      return _post(`/meet/zoom`, data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(reject);
    });
  },
  putZoom(context, data) {
    return new Promise((resolve, reject) => {
      return _put(`/meet/zoom/${data.id}`, data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(reject);
    });
  },
  deleteZoom(context, id) {
    return new Promise((resolve, reject) => {
      return _delete(`/meet/zoom/${id}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(reject);
    });
  },

  // Producer and coproducer products
  getCoproducerProducts(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      return window.axios
        .get(`/integrations/products?${queryString}`)
        .then(({ data }) => {
          context.commit("setCoproducerProducts", data);
          resolve(data);
        })
        .catch(reject);
    });
  },

  // Integrat - Eduzz
  getIntegrat(context, product_id) {
    return new Promise((resolve, reject) => {
      return _get(`integrations/integrat/product/${product_id}`)
        .then(({ data }) => {
          if (data) {
            context.commit("setPagination", {
              count: 1,
              next: null,
              previous: null
            });
          }
          context.commit("setIntegrationList", [data]);
          resolve([data]);
        })
        .catch(reject);
    });
  }
};
